import { Expose } from 'class-transformer'

export class StickerType {
  @Expose() id: number

  @Expose({ name: 'stickerImgPath' }) url: string
}
